// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"b39b41f6","422":"75f0499f","960":"8d40ab7b"}[chunkId] + ".chunk.js";
};